<template>
   <section class="section_4">
        <div class="container">
            <div class="method-to-sell">
                <div class="sell-by-category-img sell-by-category-img-1">
                    <div class="sell-by-category-img-element">
                        <img v-bind:src="imagePath + cmsData.category_left_bottom_img">
                    </div>
                </div>
                <div class="sell-by-category-img sell-by-category-img-2">
                    <div class="sell-by-category-img-element">
                        <img v-bind:src="imagePath + cmsData.category_right_img">
                    </div>
                </div>
                <div class="sell-by-category-img sell-by-category-img-3">
                    <div class="sell-by-category-img-element">
                        <img v-bind:src="imagePath + cmsData.category_left_top_img">
                    </div>
                </div>

                <div class="method-to-sell-content">
                    <div class="sell-by-category">
                        <div class="sell-by-category-content">
                            <div class="sell-by-category-title">
                                {{ cmsData.category_left_title }}
                            </div>
                            <div class="sell-by-category-grid">
                                <div class="sell-by-category-grid-content">
                                    
                                    <div class="sell-by-category-item" v-for="(row, index) in cmsSellbycat" :key="index">
                                        <a :href="'#'+row.device_link" class="sell-by-category-item-content">
                                            <div class="sell-by-category-item-img">
                                                <img :src="imageSellByCatPath + row.icon" :alt="row.icon" style="width:40px;" />
                                            </div>
                                            <div class="sell-by-category-item-title">
                                                {{row.device_name}}
                                            </div>
                                        </a>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="method-to-sell-split">
                        <div class="method-to-sell-split-content">
                            <div class="or-split">
                                <div class="or-split-content">
                                    <i class="fa fa-angle-double-right" style="color: #28a745;" aria-hidden="true"></i>
                                </div>
                                <div class="or-split-line"></div>
                            </div>
                        </div>
                    </div>

                    <div class="text-us-to-sell">
                        <div class="text-us-to-sell-content">
                            <div class="text-us-to-sell-title">
                                {{ cmsData.category_right_title }}
                            </div>
                            <div class="text-us-to-sell-contact-items">
                                <div class="text-us-to-sell-data text-us-to-sell-contact">
                                    <h3 class="text-us-to-sell-contact-number" @click="whatsAppCall('https://wa.me/'+formatPhoneNumber(cmsData.category_right_number))" style="color: #28a745; font-weight: 800; cursor:pointer;">{{ cmsData.category_right_number }}</h3>
                                </div>
                                <div class="text-us-to-sell-data text-us-to-sell-contact-message">
                                    {{ cmsData.category_right_msg }}
                                </div>
                                <div class="text-us-to-sell-data text-us-to-sell-message-us-via">
                                    {{ cmsData.category_right_sub_msg }}
                                </div>
                                <div class="text-us-to-sell-data text-us-to-sell-input-button text-us-to-sell-Facebook-Messenger">
                                    <span class="text-us-facebook-messenger btn btn-success">
                                        <a :href="'https://wa.me/'+formatPhoneNumber(cmsData.category_right_number)" class="btn btn-success" target="_blank"><i class="fab fa-whatsapp"></i> {{ cmsData.category_right_title }} </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> 
</template>

<script>
export default {
    name: "SellingMethod",
    props:['cmsData','cmsSellbycat'],
    data() {
        return {
            imagePath: this.$api + "upload/home_page_cms/",
            imageSellByCatPath: this.$api + "upload/home_start_sell/",

        }
    },
    methods:{
        formatPhoneNumber: function(messageRawNumber){
            let messageNumber=messageRawNumber.replace("-","");
                messageNumber=messageNumber.replace("(","");
                messageNumber=messageNumber.replace(")","");
                messageNumber=messageNumber.replace(" ","");
                return messageNumber;
        },
        whatsAppCall: function(callWhatsApp){
            //window.location.href=callWhatsApp;
            window.open(callWhatsApp, '_blank');
        }
    }

}
</script>

<style scoped>

</style>